import Axios from 'axios';

import { API_CLOUD_EZLO_REQUEST_URL } from 'constants/URLs';
import { CALLS } from 'constants/api';
import { axiosCloudConfig } from '../config';

/**
 * Sends the `legacy_id_mapping` Cloud API call that resolves a batch of user PKs to their UUIDs.
 *
 * Pure request: it only builds the payload and performs the call, returning the raw response so
 * callers can decide how to handle it (e.g. wrap it with `retry`). The Cloud limit is 200 ids per
 * request — batching is the caller's responsibility.
 *
 * @param {Array<string|number>} ids - User PKs (PK_User) to resolve. At most 200 per call.
 * @returns {Promise<Object>} Raw Axios response; pairs live at `response.data.data.map.user.ids_to_uuids`.
 */
export const apiGetUsersUuids = (ids) => {
    const payload = {
        call: CALLS.LEGACY_ID_MAPPING,
        params: {
            map: {
                user: {
                    ids_to_uuids: ids,
                },
            },
        },
    };

    return Axios.post(API_CLOUD_EZLO_REQUEST_URL(), payload, axiosCloudConfig());
};
